// Tick phase 6 (IMPLEMENTATION §2.4, R16): every bucketTicks the current income accumulators close into the
// total/auto rings (ringBuckets × 1 s). The readouts (averages, ETA, the HUD label switch) are in income.ts.
import type { Ctx } from '../ctx.ts';

export function runEconomy(c: Ctx): void {
  const inc = c.s.income;
  const cfg = c.d.economy.income;
  if (c.s.tick % cfg.bucketTicks !== 0) return;
  inc.total[inc.idx] = inc.accT;
  inc.auto[inc.idx] = inc.accA;
  inc.idx = (inc.idx + 1) % cfg.ringBuckets;
  inc.accT = 0;
  inc.accA = 0;
}
